//=> Import React
import React from 'react';

//=> Import plugins
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { BsInstagram } from 'react-icons/bs';
import { FaFacebookSquare } from 'react-icons/fa';

//=> Import Component
import Instagram from '../Instagram';
import CarrousselNewProduct from '../CarrousselNewProduct';

//=> Import Styles
import {
  presentation,
  presentationTop,
  gridContainer,
  imageTop,
  imageBottom,
  description,
  descriptionBottom,
  descriptionTop,
  descriptionContent,
  presentationButton,
  valeur,
  logosContainerFlex,
  containerLogo,
  logo,
} from './styles.module.scss';

//=> import Images

//=> Component
const Presentation = () => {
  //=> Component
  return (
    <section className={presentation}>
      {/* Presentation*/}
      <div className={presentationTop}>
        <p>Une boutique unique où tout (ou presque) peut se fabriquer,</p>
        <p>qui vous propose des alternatives pour un monde plus vert...</p>
        <p>Bienvenue dans l’univers de Berthe aux Pâquerettes!</p>
      </div>

      <div className={gridContainer}>
        <div
          className={imageTop}
          role="img"
          aria-label="Deventure boutique Berthe aux pâquerettes"
        />

        <div className={`${description} ${descriptionTop}`}>
          <div className={descriptionContent}>
            <h4 style={{ marginBottom: '40px' }}>
              Découvrez notre boutique...
            </h4>
            <p>
              Berthe aux Pâquerettes est une petite droguerie écologique située
              en centre ville de Carcassonne.
            </p>
            <p>
              Un concept unique en son genre, animé par notre passion pour
              l’écologie, le bien-être et le Do It Yourself!
            </p>{' '}
            <p>
              Vous y trouverez toute une gamme d’accessoires 0 déchêt, des
              produits ménagers en vrac liquide ou solide, des produits
              cosmétiques et de bien-être, tous garantis: "bio", “écocert”,
              “nature et progrès” ou encore “cosmos”, des produits de qualité en
              accord avec nos valeurs.
            </p>{' '}
            <p>
              Mais aussi et surtout, les matières premières à l’élaboration de
              vos propres produits ainsi que des ateliers de fabrication afin de
              vous guider dans une démarche plus respectueuse de l’environnement
              et de votre santé.
            </p>
            <Link to="/boutique" title="Boutique">
              <button type="button" className={presentationButton}>
                Boutique
              </button>
            </Link>
          </div>
        </div>

        <div className={`${description} ${descriptionBottom}`}>
          <div className={descriptionContent}>
            <h4 style={{ marginBottom: '40px' }}>
              ... et participez à nos atelier!
            </h4>
            <p>
              Crème de jour, bougie de massage, crème à raser, sérum, shampoing,
              Lessive, pastilles lave-vaisselle, cake à vaisselle....
            </p>{' '}
            <p>
              Fabriquer ses produits soi-même c’est choisir ses matières
              premières en fonction de soi ou de ses envies, mais c’est aussi
              s’ancrer dans une démarche plus respectueuse de la planète et
              prendre soin de sa santé.
            </p>
            <p>
              Envie d’apprendre à fabriquer vos propres produits ? Venez vivre
              une expérience sensorielle, ludique et conviviale chez Berthe aux
              Pâquerettes!
            </p>
            <p>Nos ateliers sont ouverts à tous, réservez le votre!</p>
            <Link to="/atelier" title="Atelier">
              <button type="button" className={presentationButton}>
                Atelier
              </button>
            </Link>
          </div>
        </div>

        <div
          className={imageBottom}
          role="img"
          aria-label="Intérieur boutique Berthe aux pâquerettes"
        />
      </div>

      <div className={valeur}>
        <div>
          <div className={logosContainerFlex}>
            <div className={containerLogo}>
              <div className={logo}>
                <StaticImage src="../../images/durable.png" alt="" />
              </div>
              <p>
                Chez Berthe aux Pâquerettes, on mise sur la qualité de nos produits et de nos matières premières.
              </p>
            </div>
            <div className={containerLogo}>
              <div className={logo}>
                <StaticImage src="../../images/naturel.png" alt="" />
              </div>
              <p>
                On est attentif sur la fabrication et la provenance de nos produits afin de vous offrir le meilleur.
              </p>
            </div>
            <div className={containerLogo}>
              <div className={logo}>
                <StaticImage
                  src="../../images/respectueux-de-la-nature.png"
                  alt=""
                />
              </div>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Blanditiis quaerat odit totam laborum fuga.
              </p>
            </div>
          </div>
        </div>
      </div>
      <CarrousselNewProduct />
      <Instagram />
    </section>
  );
};

export default Presentation;
